
<!-- Список значений справочника -->

<template>

	<!-- TODO Вернуть appendToBody, когда все модалки будут через mymodal -->
	<v-select :clearable="clearable" :disabled="readonly" :value="value" :options="options" :reduce="obj => obj.code" label="value" v-on:input="handle_input" clearSearchOnSelect required :appendToBody="new_modal"/>

</template>

<script>

import api from "../../api"

export default
{
	props :
	{
		id : String,
		attr_key : String,
		value : String,
		clearable : { type : Boolean, default : () => false },
		not_original : { type : Boolean, default : () => false },
		excluded : { type : Array, default : () => [] },
		new_modal : Boolean,
		readonly : Boolean,
	},

	watch :
	{
		id :
		{
			immediate : true,
			handler(id)
			{
				if(id == null)
					return

				api.call(this, "cadastral_references", "get", { id : id }, response => this.refresh_options(response.data))
			}
		},

		attr_key :
		{
			immediate : true,
			handler(attr_key)
			{
				if(attr_key == null)
					return

				api.call(this, "cadastral_attrs", "get_by", { field : "key", value : attr_key }, response => this.refresh_options(response.data.reference))
			}
		},

		excluded :
		{
			immediate : true,
			handler(excluded)
			{
				if(excluded == null || this.options_all == null)
					return

				this.options = this.options_all.filter(opt => excluded.indexOf(opt.code) < 0)
			}
		},
	},

	data()
	{
		return {
			
			options : [],
			all_options : [],

		}
	},

	methods :
	{
		handle_input(event)
		{
			this.$emit("input", event)
		},

		check()
		{
			return ( this.options.find(elem => elem.code == this.value) != undefined )
		},

		refresh_options(ref)
		{
			var options = []
			var prepared_values = new Set()
			var add = ( code, value ) => options.push({ code : code, value : value })

			if(ref.original && ! this.$props.not_original)
				Object.entries(ref.original).forEach(
					( [ code, value ] ) =>
					{
						prepared_values.add(code)
						add(code, code + " (" + value + ")")
					})

			ref.values.forEach(
				value =>
				{
					if(! prepared_values.has(value))
						add(value, value)
				})

			this.options_all = api.sort_objects_array_by_key(Array.from(options), "code")

			if(this.$props.excluded != null)
				this.options = this.options_all.filter(opt => this.$props.excluded.indexOf(opt.code) < 0)
		},
	}
}

</script>

